import Resource from "./resource";
import request from "../utils/request";

/**
 *Handles uploading and processing of files
 */
class UploadResource extends Resource {
  constructor() {
    super("uploads");
  }
  /**
   *
   * @param {FormData} formdata
   * @returns
   */
  create(formdata) {
    return request({
      url: `/${this.uri}/`,
      method: "post",
      data: formdata,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return this.destroy(id);
  }

  deleteCells(upload_file_id, rows) {
    return request({
      url: "/file/data/delete_rows/",
      method: "post",
      data: { upload_file_id, rows },
    });
  }
  /**
   * Normalize file
   * @param {Number} id
   * @returns
   */
  normalizeData(id) {
    return request({
      url: `/process/data/${id}/normalize/`,
      method: "get",
    });
  }

  getNormalizedData(id) {
    return request({
      url: `/${this.uri}/${id}/normalized_data/`,
      method: "get",
    });
  }

  getOrdinaryData(id) {
    return request({
      url: `/${this.uri}/${id}/ordinary_data/`,
      method: "get",
    });
  }

  performDuplicatesCheck(id) {
    return request({
      url: `/process/data/${id}/duplicate_check/`,
      method: "get",
    });
  }

  performDuplicatesCheckDB(id) {
    return request({
      url: `/process/data/${id}/database_check/`,
      method: "get",
    });
  }
  push(id) {
    return request({
      url: `/pusher/data/${id}/push/`,
      method: "get",
    });
  }
}

export { UploadResource as default };
